import { h, Component } from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import MenuObject from '../canvas/menu-object';
import util from "../util";
import { markAsModified } from "../canvas/mark-as-modified";
import store from '../store';
import designDomain from '../domain/designDomain';
import { addComponent, VIEWPORT_CENTER } from '../canvas/component';
import React from "preact/compat";
import AsideMenuObjectText from './AsideMenuObjectText';

const { goToView } = actions;

const ITEMS = 'items';
const EDIT = 'edit';
const ADD_NEW = 'add-new';
const DESIGNS = 'designs';
const IMPORT = 'import';
const SELECT_OM = 'select-om';

export default @connect(reduce, actions)
class MenuObjectContent extends Component {
  constructor(props) {
    super();

    this.state = {
      items: store.getState().menuObjectItems,
      active: null,
      activeIdx: '',
      scrollToBottomSectionId: false,
    }
  }

  sort(sortedList, event) {
    markAsModified();
    const items = sortedList.map(i => i.item);

    this.setState({ items, });
    store.dispatch(actions.setMenuObjectItems(items));
    MenuObject.updateContent(this.props.$element, items);
  }

  resetSelectedOnlineMenu() {
    this.props.setOnlineMenuImport(null);
  }

  goToSavedItems() {
    store.dispatch(goToView('mo-import'));

    if (this.props.menuObjectImportDesign) {
      this.goToImport(this.props.menuObjectImportDesign);
      return;
    }

    if (this.props.onlineMenuImport) {
      this.goToImportOnlineMenu(this.props.onlineMenuImport);
      return;
    }

    store.dispatch(actions.goToSubview(DESIGNS));
  }

  goToImport(designId) {
    this.setState({ designId });
    store.dispatch(actions.goToSubview(IMPORT));
  }

  goToImportOnlineMenu(onlineMenu) {
    this.setState({ onlineMenu });
    store.dispatch(actions.goToSubview(IMPORT));
  }

  addNewItem(isMODeleted = false) {
    markAsModified();
    const active = new MenuObject.MenuItem();
    const items = isMODeleted ? [active] : [...store.getState().menuObjectItems, active];
    store.dispatch(actions.setMenuObjectItems(items));
    store.dispatch(actions.setIsMenuObjectCopied(false));

    $('.items-list').animate({ scrollTop: $('.items-list').prop("scrollHeight") }, 500);

    if (isMODeleted) MenuObject.updateContent(this.props.$element, items);

    this.setState(old => ({
      items,
      active,
      activeIdx: isMODeleted ? 0 : old.items.length + 1,
      scrollToBottomSectionId: true,
      isEditMode: true
    }));

    store.dispatch(actions.goToSubview(ADD_NEW));
  }

  removeItem(idx) {
    markAsModified();
    let items = [...this.state.items];
    items.splice(idx, 1);

    if (items.length === 0) {
      this.addNewItem(true);
    } else {
      this.setState({ items: items, active: null, activeIdx: '' });
      store.dispatch(actions.setMenuObjectItems(items));
      MenuObject.updateContent(this.props.$element, items);
    }
  }

  editItem(idx) {
    markAsModified();
    this.setState({ activeIdx: idx });
    store.dispatch(actions.goToSubview(EDIT));
  }

  save() {
    MenuObject.updateContent(this.props.$element, this.state.items);
    this.closeEditMode();
  }

  saveItem(updated) {
    markAsModified();
    this.setState(old => {
      let items = [...old.items];
      items.splice(old.activeIdx, 1, updated);
      return {
        items
      }
    });

    store.dispatch(actions.goToSubview(ITEMS));

    if (store.getState().isMobileVersion) {
      util.nextTick(() => {
        MenuObject.updateContent(MenuObject.getActive(), this.state.items);
      }, 50);
    }
  }

  saveItemAndNew(updated) {
    markAsModified();
    this.saveItem(updated);
    this.addNewItem(false);
  }

  selectDesign(id, name) {
    this.props.setMenuObjectImportDesign(id);
    this.props.setMenuObjectImportName(name);
    util.nextTick(() => {
      this.goToImport(id);
    });
  }

  selectLocation(id) {
    this.props.setMenuObjectImportLocation(id);
  }

  closeEditMode() {
    this.setState({ view: ITEMS, active: null, activeIdx: '' });
  }

  componentDidMount() {
    if (!!this.props.menuObjectItems) {
      this.setState({
        items: [...this.props.menuObjectItems]
      });
    }
  }

  goToItems() {
    store.dispatch(goToView('text-mo-edit'));
    store.dispatch(actions.goToSubview(ITEMS));
  }

  updateList() {
    this.setState({ items: this.props.menuObjectItems });
  }

  menuContentModalClick(ev) {
    console.log("on menu content click");
    if ($(ev.target).closest('.dropdown-toggle').length === 0) {
      ev.stopPropagation();
    }
    if ($(ev.target).closest('.dropdown-menu').length === 0 && $(ev.target).closest('.dropdown-toggle').length === 0) {
      util.hideDropdown();
    }
  }

  newMenuObject() {
    store.dispatch(actions.deselect());

    const mo = new designDomain.MenuObject({
      config: MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE,
      content: '[{"name":"","description":"","prices":[]}]'
    })
    const html = MenuObject.getHtmlContent(mo.content, mo.config);

    const $page = util.getPageInViewport($('.page'));
    addComponent($page.attr('id'), html, {
      position: {
        left: VIEWPORT_CENTER,
        top: VIEWPORT_CENTER
      },
      isFromTemplate: true,
      keepColors: true
    });

    const items = [new MenuObject.MenuItem()];
    store.dispatch(actions.setMenuObjectItems(items));

    this.setState({
      items,
      activeIdx: 0,
      isEditMode: true,
      scrollToBottomSectionId: true,
    });

    store.dispatch(actions.goToView('text-mo-edit'));
    store.dispatch(actions.goToSubview(ADD_NEW));
  }

  addExampleItemsToMenu(layout, items) {
    const defaultLayoutConfig = JSON.parse(MenuObject.getFirstMenuItemConfig() || MenuObject.DEFAULT_MO_STYLE);
    const nameLayoutConfig = { ...defaultLayoutConfig.styles.name, "font-size": "110%", "text-transform": "none" };
    const priceLayoutConfig = { ...defaultLayoutConfig.styles.price, "font-size": "110%" };
    const descriptionLayoutConfig = { ...defaultLayoutConfig.styles.description, "font-size": "100%" };

    const mo = new designDomain.MenuObject({
      config: JSON.stringify({ ...defaultLayoutConfig, styles: { ...defaultLayoutConfig.styles, name: nameLayoutConfig, description: descriptionLayoutConfig, price: priceLayoutConfig }, layout: layout }),
      content: JSON.stringify(items)
    })

    const html = MenuObject.getHtmlContent(mo.content, mo.config);
    const $page = util.getPageInViewport($('.page'));

    addComponent($page.attr('id'), html, {
      position: {
        left: VIEWPORT_CENTER,
        top: VIEWPORT_CENTER
      },
      isFromTemplate: true,
      keepColors: true
    });

    if (store.getState().isMobileVersion) {
      store.dispatch(actions.setIsMobileAside(true));
    } else {
      this.setState({ items: items, isEditMode: true });
      store.dispatch(actions.goToSubview(ITEMS));
    }

    markAsModified();
  }

  render(props, state) {
    const isMoDeselected = (props.$element === null || Object.keys(props.menuObjectStyles).length === 0 || !MenuObject.isMenuObject(props.$element));

    if (JSON.stringify(store.getState().menuObjectItems) !== JSON.stringify(this.state.items)) {
      state = {
        items: store.getState().menuObjectItems,
        active: null,
        activeIdx: '',
        view: ITEMS,
      };
      this.setState(state);
    }

    return (
      <span>
        {(props.subview === ITEMS || props.subview === EDIT || props.subview === ADD_NEW || (props.view === 'text-mo-edit' || props.view === 'text-mo-style' || props.view === 'text-mo-layout' || props.view === 'text-mo-spacing' || props.view === 'text-mo-import' || props.view === 'text-plain')) &&
          <AsideMenuObjectText newMenuObject={props.newMenuObject} addExampleToMenu={this.addExampleItemsToMenu} isPlainText={props.isPlainText} />
        }
      </span>
    );
  }
}
